import { useMutation } from '@tanstack/react-query';
import queryString from 'query-string';

import { apiRequest } from 'app/utils/request/api';

const bookingsCsvPath = '/extranet/:hotelId/bookings/csv' as const;

export function useBookingsCsvDownload() {
  return useMutation({
    mutationFn: async (params: {
      hotelId: number;
      search?: string;
      sorting?: string;
      beginning?: string;
      ending?: string;
      status?: string[];
      vccStatus?: string[];
      packageIds?: number[];
    }) => {
      const { hotelId, ...rest } = params;

      return apiRequest({
        path: `${bookingsCsvPath}?${queryString.stringify(rest)}`,
        params: {
          hotelId: hotelId.toString(),
        },
      });
    },
  });
}
